import {CreateInstance} from './config'
const messageAPI = CreateInstance('message')
export default messageAPI
